// accordions js start  
function faq_taggol() {  
        const accordions = document.querySelectorAll("[js-acc-item]");
        const openAccordion = (accordion) => {
          accordion.scrollTo(0,0);
          const content = accordion.querySelector("[js-acc-single-content]");
          accordion.classList.add("active");
          const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
          content.style.maxHeight = 'max-content';
        };
        
        const closeAccordion = (accordion) => {
          const content = accordion.querySelector("[js-acc-single-content]");
          accordion.classList.remove("active");
          if(content){
            content.style.maxHeight = null;
          }
        };
        
        accordions.forEach((accordion) => {
          const intro = accordion.querySelector("[js-acc-single-trigger]");
          const content = accordion.querySelector("[js-acc-single-content]");
          if(intro){
              intro.onclick = (e) => {
                if (content.style.maxHeight) {
                  closeAccordion(accordion);
                } else {
                  accordions.forEach((accordion) => closeAccordion(accordion)); 
                  openAccordion(e.target.closest('[js-acc-item]'));
                } 
              };
          }
        });        
  }
faq_taggol(); 
 
//currency change
$('body').find('.currency_selector_flag .slected_currency').on('click', function(){
    $("ul.all_currency").toggle();
});

/// Select all 'li' elements inside the 'ul.all_currency'
var currencyItems = document.querySelectorAll('.currency_selector_flag ul.all_currency li');

currencyItems.forEach(function(item) {
  item.addEventListener('click', function() {
    var value = item.getAttribute('value');
    var imageSrc = item.querySelector('img').getAttribute('src');
    var selectedCurrency = document.querySelector('.currency_selector_flag .slected_currency');
    selectedCurrency.querySelector('img').setAttribute('src', imageSrc);
    selectedCurrency.querySelector('span').innerHTML = value;
    
    var currencyList = document.querySelector('ul.all_currency');
    currencyList.style.display = (currencyList.style.display === 'none' || currencyList.style.display === '') ? 'block' : 'none';
    
    // Update the URL with the selected currency
    var currentUrl = new URL(window.location.href);
    console.log("Current URL before update:", currentUrl.toString());
    
    // Set or update the 'currency' query parameter
    currentUrl.searchParams.set('currency', value);
    
    console.log("Updated URL:", currentUrl.toString());
    
    // Redirect to the updated URL
    window.location.href = currentUrl.toString();
  }); 
});

//home page befor-after tab
 const tabTitles = document.querySelectorAll('.tab-title');
 if(tabTitles){
  document.addEventListener('DOMContentLoaded', function () {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');
    
    tabTitles.forEach(tab => {
      tab.addEventListener('click', function () {
        const targetId = this.getAttribute('data-tab-id');
        tabTitles.forEach(t => t.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        document.getElementById(targetId).classList.add('active');
      });
    });
  
    if (tabTitles.length > 0) {
      tabTitles[0].classList.add('active');
      tabContents[0].classList.add('active');
    }
  });
}
  
//currency dropdown
  document.addEventListener('click', function (event) {
  var currency = document.querySelector(".slected_currency");
   if(currency){    
     if(event.target != currency && !event.target.closest(".all_currency")){
        let siblingElement = currency.closest(".currency_selector_flag").querySelector(".all_currency");
        siblingElement.style.display="none";
     }
   }
});

// Testimonial section 
var second_block = document.querySelector('.visual_blocks_wrapper');  
  if(second_block){
     document.addEventListener('DOMContentLoaded', function() {
        var elements = document.querySelectorAll(".visual_block");
        var second_block = document.querySelector('.visual_blocks_wrapper');
        var childClass = second_block.querySelector('.second_img');
        var second_testimonial = document.querySelector('.second_testimonial');  
    
        elements.forEach(function(element) {
            element.addEventListener('mouseover', function(event) {
                second_testimonial.classList.remove("active");
                event.target.classList.add('active'); 
                var hover = this.nextElementSibling;
                if (hover) {
                    hover.style.opacity = 1;
                }
            });
    
            element.addEventListener('mouseout', function(event) {
                second_testimonial.classList.add("active");
                event.target.classList.remove('active');
                var hover = this.nextElementSibling;
                if (hover) {
                    hover.style.opacity = 0;
                }
            });
        });
    
        document.addEventListener('mouseover', function(event) {
            if (![...elements].some(el => el.contains(event.target))) {
                childClass.style.opacity = 1;
            }
        });
    
        document.addEventListener('mouseout', function(event) {
            if (![...elements].some(el => el.contains(event.target))) {
                childClass.style.opacity = 1;
            }
        });
    });
    
      document.addEventListener('DOMContentLoaded', function() {
        var elements = document.querySelectorAll(".visual_block");
        var second_block = document.querySelector('.visual_blocks_wrapper');
        var childClass = second_block.querySelector('.second_img');
        var second_testimonial = document.querySelector('.second_testimonial');
        if(elements){
          elements.forEach(function(element) {
            element.addEventListener('mouseover', function(event) {
                second_testimonial.classList.remove("active");
                event.target.classList.add('active');
                elements.forEach(el => {  
                    var hover = el.nextElementSibling;
                    if (hover) {
                        hover.style.opacity = 0;
                    }
                });
                var hover = this.nextElementSibling;
                if (hover) {
                    hover.style.opacity = 1;
                }
            });
          
            element.addEventListener('mouseout', function(event) {
                second_testimonial.classList.add("active");
                event.target.classList.remove('active');
                var hover = this.nextElementSibling;
                if (hover) {
                    hover.style.opacity = 0;
                }
            });
        });
        }
        
    
        document.addEventListener('mouseover', function(event) {
            if (![...elements].some(el => el.contains(event.target))) {
                childClass.style.opacity = 1;
            }
        });
    
        document.addEventListener('mouseout', function(event) {
            if (![...elements].some(el => el.contains(event.target))) {
                childClass.style.opacity = 1;
            }
        });
    });
  } 

//before-after section img default css
var elements = document.querySelectorAll(".foreground-img");
  if(elements){
     document.addEventListener('DOMContentLoaded', function() {
      var elements = document.querySelectorAll(".foreground-img");
      elements.forEach(function (element) {
        element.style.width = "50%" ;
      });
    });
  }
 
// ==========swiper ===========
new Swiper('.swiper-container.collection_list_slider', {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 2.4,
        paginationClickable: true,
        allowTouchMove: true,
        spaceBetween: 20,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
          0: {
              slidesPerView: 1.2,
              spaceBetween: 12
          },
          601: {
              slidesPerView: 2.4,
              spaceBetween: 12
          }
      }
    });

$(document).ready(function() { 

  //faq section slider home page 
  new Swiper('.swiper-container.faq_slider', {
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        grabCursor: true,
        paginationClickable: false,
        breakpoints: {
          0: {
              slidesPerView: 1.3,
              spaceBetween: 12
          },
          601: {
              slidesPerView: 2.5,
              spaceBetween: 12
          },
          993: {
              slidesPerView: 1.9,
              spaceBetween: 12
          }
      }
    });
  
  new Swiper('.swiper-container.testimoial_slider', {
        loop: false,
        autoplay: {
          delay:30000,
        },
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        pagination: {
           el: '.swiper-pagination',
		   clickable: true,
        },
        slidesPerView: 2,
        grabCursor: true,
        paginationClickable: false,
        spaceBetween: 20,
        breakpoints: {
          0: {
              slidesPerView: 1,
              spaceBetween: 0
          },
          601: {
              slidesPerView: 1,
              spaceBetween: 0
          },
          1024: {
              slidesPerView: 1.3, 
              spaceBetween: 12
          },
          1028: {
              slidesPerView: 2, 
              spaceBetween: 12
          },
          2000: {
              slidesPerView: 2,
              spaceBetween: 12
          }
      }
    });
  
  new Swiper('.swiper-container.media_logo_slider', { 
  loop: true,
  grabCursor: true,
  speed: 3000,
  autoplay: {
    delay: 100,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  slidesPerView: 5,
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: {
      slidesPerView:2,
      spaceBetween: 12,
    },
    601: {
      slidesPerView: 4,
      spaceBetween: 12,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 12,
    }
  }
});

  //testimonial slider home page 
  if (screen.width < 769) {
    new Swiper('.swiper-container.reviews_block_slider', { 
              loop: true,
              scrollbar: {
                el: '.swiper-scrollbar.swiper-scrollbar_review',
                draggable: true
              },
              slidesPerView: 3,
              paginationClickable: true,
              spaceBetween: 20,
              breakpoints: {
                  768: { 
                      slidesPerView: 2,
                      spaceBetween: 30
                  },
                  600: {
                      slidesPerView: 2,
                      spaceBetween: 30
                  },
                  0: {
                      slidesPerView: 1,
                      spaceBetween: 10
                  }
              }
          });
  }

});

var staging_sec_width = document.querySelector(".new_thre_sides_full_width");
var slidesPerViewValue = 2.3;
if( staging_sec_width ) {
    slidesPerViewValue = 4;
}

new Swiper('.swiper-container.staging-project', {
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        grabCursor: true,
        paginationClickable: false,
        slidesPerView: slidesPerViewValue,
        breakpoints: {
          0: {
              slidesPerView: 1.3,
              spaceBetween: 12
          },
          749: {
              slidesPerView: 2.2,
              spaceBetween: 12
          },
          993: {
              slidesPerView: 3.1,
              spaceBetween: 16
          },
          1199: {
              slidesPerView: slidesPerViewValue,
              // slidesPerView: 2.65,
              spaceBetween: 24
          }
      }
    });

// tabifier location page 
$(document).ready(function() {
  
    $('ul.tabnav li:first-child a').addClass('active');  
    $('.tabcontent').first().show();
    $('ul.tabnav li a').click(function() { 
    	var target = $(this).attr('href');
    	$(this).addClass('active').closest('li').siblings().find('a').removeClass('active');
    	$(target).show().siblings('.tabcontent').hide();
    	return false;
    }); 
  
});  

// location pages slider
var swiper = new Swiper('.swiper-container.location_gallery', {
	pagination: {
      el: '.swiper-pagination',
      clickable: true
	},
	navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
	},
	autoplay: {
    delay: 6000,
	disableOnInteraction: false
    }, 
	loop: true,
    allowTouchMove: false,
	watchSlidesProgress: true,
        on : {
        slideChange: function () {
                $('.swiper-pagination-bullet').each(function(index) {                        
                  if (!$(this).hasClass("swiper-pagination-bullet-active")) {
                  $(this).addClass('swiper-pagination-bullet-active');            
                  }else{
                  return false
                }
             });
        }
        }
});
 
// video play and pause
var play_icons = document.querySelectorAll(".play-gif");
  if(play_icons){
  play_icons.forEach(function(play_icon){
    play_icon.addEventListener('click',function(e){
     
      var parentElement = this.closest(".play-button-wrapper");
      var video_block = parentElement.closest(".video-container");
            console.log("video_block",video_block);
      var video = video_block.querySelector("video");
      var src_val = video.getAttribute("data-src");
      video_block.querySelectorAll(".video-container source").forEach(x=> x.setAttribute("src",src_val));
        if(video.paused){
            video.load();
            video.play();
            var img = play_icon.querySelector("img").classList.add("hidden");
        }else{
          video.pause();
          var img = play_icon.querySelector("img").setAttribute("src","https://cdn.shopify.com/s/files/1/0052/2085/9992/files/Frame_23859.png?v=1727872257");
        }
      });
    });
}

//video play and pause for the header
 var play_icons = document.querySelectorAll(".video_play_btn_popup");
    if(play_icons){
    play_icons.forEach(function(play_icon){
      play_icon.addEventListener('click',function(e){
        var video_block = play_icon.closest(".video_wrap");              
        var video = video_block.querySelector("video");
        var src_val = video.getAttribute("src");

        video_block.querySelectorAll(".video_wrap source").forEach(x=> x.setAttribute("src",src_val));
          if(video.paused){
              video.load();
              video.play();
             var img_icon = play_icon.closest(".video_play_btn_popup");
              var img = play_icon.querySelector("img").classList.add("hidden");
              var img = play_icon.querySelector("img").setAttribute("src","https://cdn.shopify.com/s/files/1/0052/2085/9992/files/png-transparent-computer-icons-alarm-clocks-watch-pause-button-miscellaneous-food-text-thumbnail-removebg-preview.png?v=1736142771");
          }else{
            video.pause();
             var img = play_icon.querySelector("img").classList.add("hidden");
            var img = play_icon.querySelector("img").setAttribute("src","https://cdn.shopify.com/s/files/1/0052/2085/9992/files/Polygon_3.png?v=1728463255");
          }
        });
      });           
 } 

// About page Blog Slider 
new Swiper('.swiper-container.custom-blog', {
    loop: true,
    autoplay: {
         delay: 2000,
         disableOnInteraction: false,
    },
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    pagination: {
       el: '.swiper-pagination',
       clickable: true,
    },
    slidesPerView: 3,
    grabCursor: true,
    paginationClickable: false,
    spaceBetween: 8,
    breakpoints: {
      0: {
          slidesPerView: 1.4,
      },
      768: {
          slidesPerView: 3.2,
      },
      989: {
          slidesPerView: 5.2, 
      },
      1280: {
          slidesPerView: 6, 
      }
  }
});

//blog post slider
new Swiper('.swiper-container.swiper-blog-post', {
    loop: true,
     navigation: {
      nextEl: ".swiper_control_arrow .swiper-button-next",
      prevEl: ".swiper_control_arrow .swiper-button-prev"
    },  
    slidesPerView: 3.5,
    grabCursor: true,    
    spaceBetween:15,
    breakpoints: {
      0: {
          slidesPerView:1.2,
      },
      989: {
          slidesPerView:2.2, 
      },
      1280: {
          slidesPerView:3.2, 
      }
  }
});

//instafeed gallery
var gallery_slider = new Swiper(".autoplay-slider", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    820: {
      slidesPerView: 5, 
      spaceBetween: 20 
    },
    749: {
      slidesPerView: 4,
      spaceBetween: 10
    },
    0: {
      slidesPerView: 2,
      spaceBetween: 10 
    }
  }
});

//multicolumn section second
var gallery_slider = new Swiper(".multicolumn.second .swiper-container", {
  breakpoints: {
    990: {
      slidesPerView: 3, 
      spaceBetween: 22
    },
    749: {
      slidesPerView: 2,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination.second',
        clickable: true,
      },
      navigation: {
        nextEl: '.next-second',
        prevEl: '.prev-second',
      },
      autoplay: {
        delay: 0, 
        disableOnInteraction: false,
        paginationClickable: true
      }
    },
    0: {
      slidesPerView: 1,
      spaceBetween:  0,
      pagination: {
        el: '.swiper-pagination.second',
        clickable: true,
      },
      navigation: {
        nextEl: '.next-second',
        prevEl: '.prev-second',
      },
      autoplay: {
        delay: 0, 
        disableOnInteraction: false,
        paginationClickable: true,
        
      }
    }
  }
});

//case study list slider
new Swiper('.case-study .swiper-container', {
    loop: true,
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween:20,
    autoHeight: true,
    navigation: {
      nextEl: '.case-study-arrows .slider__button-next',
      prevEl: '.case-study-arrows .slider__button-prev'
    },
    pagination: {
       el: '.swiper-pagination.cases',
       clickable: true,
    },
});   

// virtual-staging-in-real-estate page in two section marge
const div1 = document.querySelector('.template-virtual-staging-real-estate .service_address');
const div2 = document.querySelector('.template-virtual-staging-real-estate .cutsom_blog_section');
  if(div1 && div2){
    const wrapper = document.createElement('div');
    wrapper.className = 'merged-section-bg';
    div1.parentNode.insertBefore(wrapper, div1);
    wrapper.appendChild(div1);
    wrapper.appendChild(div2);
  }

//blog-page wrap 2 section 
const sec1 = document.querySelector('.team-deatils-sec');
const sec2 = document.querySelectorAll('.multiple-cust');
if(sec1 && sec2){
  const wrapper = document.createElement('div');
  wrapper.className = 'merged-section-bg-blog';
  sec1.parentNode.insertBefore(wrapper, sec1);
  wrapper.appendChild(sec1);
  sec2.forEach(function(item) {
    wrapper.appendChild(item);  
  });
} 
 
////servie list slider
var galleryTop = new Swiper('.services-list-slider .slider-2', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.slider__button-next',
        prevEl: '.slider__button-prev',
      },
      slidesPerView: 3,
      loop: true,
      spaceBetween: 23,
      loopedSlides: 3,
      autoHeight: true,
      slideToClickedSlide: true,
    pagination: {
    el: '.slider__pagination',
    clickable: true,
  },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 23
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 23
        }
    }	 		
});

// popup open in mega-menu
 const triggerElement = document.querySelector('.inquire_form_trigger');
 const menu_trigers = document.querySelectorAll(".popup_grandchild");
  menu_trigers.forEach(function(menu) {
    menu.addEventListener("click",function (e) {
      console.log(event.target.hash === "#popupinquire")
      const is_add = event.target.hash === "#popupinquire";
      if(is_add)
      {        
        event.preventDefault();
        const button = document.querySelector('#popupinquiry'); 
        if (button) {
          button.click(); 
        }
      }
    })    
  })
  if (triggerElement) {
    triggerElement.addEventListener('click', function () {
console.log("triggerElement",triggerElement);
      
      const button = document.querySelector('#popupinquiry'); 
      if (button) {
        button.click(); 
      }
    });
  }

// on change on pdp page 
const checkbox = document.getElementById('toggleCheckbox');
if(checkbox){
   checkbox.addEventListener('change', function() {
    const radioButtons = document.querySelectorAll('input[type="radio"].style-option');
    var stdText = document.querySelector("#stdText")?.innerText;
    var selectedValue = document.querySelector("[selected-var]");  
    var selectedAttr = selectedValue?.getAttribute("selected-var");
    radioButtons?.forEach(function(radio) {
      if (checkbox.checked ) {       
          if(radio.value != stdText){
         selectedValue.setAttribute("selected-var",radio.value) 
          radio.click();
        }  
      }else{
        if( radio.value == stdText)
       {  
         selectedValue.setAttribute("selected-var",radio.value)
         radio.click();
       }       
      }      
    });
     // card in active class set on checkbox check
     var selectedAttr = selectedValue.getAttribute("selected-var");
     var card_variant = document.querySelectorAll(".pricing-list .pricing-card");
      card_variant?.forEach(function (card_var) {
        var var_name = card_var.getAttribute("variant-name");
         if ( var_name == selectedAttr )
         {         
           card_var.classList.add("active");
         }else{
           card_var.classList.remove("active");           
         }
      })
  });
}

document.addEventListener("DOMContentLoaded", function () {
    var customButtons = document.querySelectorAll(".pricing_cart_btn a");
    var addToCartButton = document.querySelector(".product-form__submit");
    var quantityInput = document.querySelector(".virtual_qty input[name='quantity']");
    var selectedValue = document.querySelector("[selected-var]")   
    var stdText = document.querySelector("#stdText");
    var besText = document.querySelector("#besText");
    var attr_Selected = selectedValue?.getAttribute("selected-var") || null; 
    var set_var = document.querySelector(".on_offtoggle ");
    var card_variant = document.querySelectorAll(".pricing-list .pricing-card");
    var is_pricing = window.location.toString().includes("pricing");

  // card section on pricing page
      if(is_pricing){
        if(checkbox){
          checkbox.addEventListener('change', function() {
            if (checkbox.checked ) {
              besText.classList.add("active");           
              stdText.classList.remove("active");
              set_var.setAttribute("data-variant",besText.innerText); 
            }
           else{
              stdText.classList.add("active");
              besText.classList.remove("active"); 
              set_var.setAttribute("data-variant",stdText.innerText)                                   
           }
            card_variant.forEach(function (card_var) {             
            var var_name = card_var.getAttribute("variant-name");
            var selectedVar = set_var.getAttribute("data-variant");              
              if(selectedVar){
               if ( var_name == selectedVar ){   
                   card_var.classList.add("active");
               }
               else{
                   card_var.classList.remove("active");           
                 } 
              }      
            });           
         });
          
          stdText.classList.add("active");
          besText.classList.remove("active"); 
          set_var?.setAttribute("data-variant",stdText.innerText)     
        }
      }
         
  // pdp page card
  var selectedAttr = selectedValue?.getAttribute("selected-var");
  card_variant.forEach(function (card_var) {
  var button_link = card_var.querySelector(".card_link");
  var var_name = card_var.getAttribute("variant-name");          
   if(is_pricing){
     var selectedVar = set_var.getAttribute("data-variant");           
     if(selectedVar && is_pricing){
         if ( var_name == selectedVar ){   
             card_var.classList.add("active");
         }
         else{
             card_var.classList.remove("active");           
           } 
        }      
   }              
    if(selectedAttr){
      // redio button active on refresh
      set_var?.setAttribute("data-variant",selectedAttr);
      var selectedVar = set_var?.getAttribute("data-variant");              
          if(selectedVar){
            if (selectedVar === stdText.innerText) {
                checkbox.checked = false;
              stdText.classList.add("active");
              besText.classList.remove("active");
            } else {
              checkbox.checked = true;
               stdText.classList.remove("active");
              besText.classList.add("active");
            }                               
          }    
       // page refresh active card        
       if ( var_name == selectedAttr )
       {                 
         card_var.classList.add("active");
       }else{
         card_var.classList.remove("active");           
       } 
    }                     
  })
  
  // button click in pdp
  if (customButtons.length > 0 && addToCartButton && quantityInput) {
          customButtons.forEach(function (customButton) {
            customButton.addEventListener("click", function (event) {
              var qty = customButton.closest(".pricing_cart_btn").getAttribute("data-qty");
              if (qty) {
                quantityInput.value = qty;
              }
              addToCartButton.click();
            });
          });
        }   
  
  if(attr_Selected != null && stdText){      
      var card_variant = document.querySelectorAll(".pricing-list .pricing-card");
        card_variant.forEach(function (card_var) {
          var var_name = card_var.getAttribute("variant-name");
           if ( var_name == attr_Selected )
           {
             card_var.classList.add("active");
           }else{
             card_var.classList.remove("active");           
           }
        })    
    }
  
  var selectedAttr = selectedValue?.getAttribute("selected-var");
  var card_variant = document.querySelectorAll(".pricing-list .pricing-card");
  card_variant.forEach(function (card_var) {
    var var_name = card_var.getAttribute("variant-name");
    if(selectedAttr){
     if ( var_name == selectedAttr )
     {              
       card_var.classList.add("active");
     }else{
       card_var.classList.remove("active");           
     } 
    }         
  })
  
  // cust-dropdown
  const variantOptions = document.querySelector('.variant-options');
  const selectedValueEl = document.getElementById('selectedValue');
  const variantItems = document.querySelectorAll('.variant-option');
  const radioButtons = document.querySelectorAll('input[type="radio"].style-option');   
  selectedValueEl?.addEventListener('click', function () {
    variantOptions.style.display = (variantOptions.style.display === 'none') ? 'block' : 'none';  
     variantItems.forEach(item => {
      item.addEventListener('click', function () {
        const value = this.dataset.value;
        selectedValueEl.innerText = value;
        selectedValueEl.setAttribute('selected-var', value);
        variantOptions.style.display = 'none';
  
        radioButtons?.forEach(function(radio) {  
         if( radio.value == value)
         {  
           selectedValue.setAttribute("selected-var",radio.value)
           radio.click();
         }     
      }); 
      });
    });
  });
  
  //virtual staging in  tab
  const tabs = document.querySelectorAll('.mobile-tab-btn');
  const contents = document.querySelectorAll('.mobile-tab-content');  
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));
      this.classList.add('active');
      document.getElementById(this.dataset.tab).classList.add('active');
    });
  });

  // staging pdp change on the url
  const queryString = window.location.search; 
  if(window.location.href.includes("quntity")){
      if(radioButtons.length > 0 ){
        radioButtons.forEach(function(radio) {  
           const urlParams = new URLSearchParams(queryString);
           const url_qty = urlParams.get('quntity');             
            if (url_qty) {
              quantityInput.value = url_qty;             
              var price = document.querySelector("[total-price]")?.getAttribute("total-price");
              var compre = document.querySelector("[compare-total-price]")?.getAttribute("compare-total-price");
              if(price){
                var total_price = url_qty * price ; 
                var compre_total = url_qty * compre;
                var compre_new_price =  Shopify.formatMoney(compre_total, Shopify.currency.active_format || Shopify.money_format);
                var new_price = Shopify.formatMoney(total_price, Shopify.currency.active_format || Shopify.money_format);
                document.querySelector(".compare-total-price").innerHTML = compre_new_price;
               document.querySelector(".total-price").innerHTML = new_price;
              }
            }         
        }); 
      }else{
        const urlParams = new URLSearchParams(queryString);
        const url_qty = urlParams.get('quntity');  
            if (url_qty) {
              quantityInput.value = url_qty;             
              var price = document.querySelector("[total-price]")?.getAttribute("total-price");
              var compre = document.querySelector("[compare-total-price]")?.getAttribute("compare-total-price");
              if(price){
                var total_price = url_qty * price ; 
                var compre_total = url_qty * compre;
                var compre_new_price =  Shopify.formatMoney(compre_total, Shopify.currency.active_format || Shopify.money_format);
                var new_price = Shopify.formatMoney(total_price, Shopify.currency.active_format || Shopify.money_format);
                 document.querySelector(".compare-total-price").innerHTML = compre_new_price;
               document.querySelector(".total-price").innerHTML = new_price;
              }
            }  
      }      
    }

  const variantCards = document.querySelectorAll("variant-selects .info_text");    
  variantCards.forEach(function (card) {        
        card.style.display = "none";
      });
  
});

  function openForm(){
        document.getElementById("popupForm").classList.add("form_get");
        document.getElementById("overlay").classList.add("overlay1");
        var element=document.getElementById("popupForm");
        element.classList.add("form_get");
        var element1=document.getElementById("overlay");
        element1.classList.add("overlay1");
      }
  function closeForm(){ 
        document.getElementById("popupForm").classList.remove("form_get");
    document.getElementById("overlay").classList.remove("overlay1");
        var element=document.getElementById("popupForm");
		element.classList.remove("form_get");
        var element1=document.getElementById("overlay");
        element1.classList.remove("overlay1");
      }

window.addEventListener("click", function(event) {
    var popup = document.getElementById("popupForm");
    var overlay = document.getElementById("overlay");

    if (event.target === overlay) {
      closeForm();
    }
});

const main_div = document.querySelector(".footer-block__details-content .has_footer_submenu");
main_div?.addEventListener("click", function(event) {
  const child_div = document.querySelector(".footer-block__details-content .footer-block__details-content--second-level");
  child_div.classList.toggle("active");
});
document.addEventListener("click", function(event) {
  const footerContent = document.querySelector(".footer-block__details-content");
  if (footerContent && !footerContent.contains(event.target)) {
    const child_div = document.querySelector(".footer-block__details-content .footer-block__details-content--second-level");
    child_div?.classList.remove("active");
  }
});

// document.querySelectorAll('.has_footer_submenu .list-menu__item--link').forEach(link => {
//   link.style.pointerEvents = 'none';
// });
